import { GlIntersectionObserver } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { humanize } from '~/lib/utils/text_utility';
import EmojiGroup from './emoji_group.vue?vue3';
export default {
    name: 'EmojiCategory',
    components: {
        GlIntersectionObserver,
        EmojiGroup
    },
    props: {
        category: {
            type: String,
            required: true
        },
        emojis: {
            type: Array,
            required: true
        }
    },
    emits: [
        'appear',
        'click'
    ],
    data () {
        return {
            renderGroup: false
        };
    },
    computed: {
        categoryTitle () {
            return humanize(this.category);
        }
    },
    methods: {
        categoryAppeared () {
            this.renderGroup = true;
            this.$emit('appear', this.category);
        },
        onClick (emoji) {
            this.$emit('click', {
                category: this.category,
                emoji
            });
        }
    }
};
